/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { ImgHTMLAttributes } from 'react';
import { useThemeMode } from '@features/theme/context/ThemeContext';
import { getThemedLogoSrc } from '@features/theme/utils/dark-logo-map';

export interface ThemedImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string | undefined;
  darkSrc?: string;
}

export const ThemedImage = ({ src, darkSrc, alt, ...props }: ThemedImageProps) => {
  const { isDarkMode } = useThemeMode();

  const resolvedSrc = isDarkMode
    ? (darkSrc ?? getThemedLogoSrc(src, true) ?? src)
    : src;

  if (!resolvedSrc) {
    return null;
  }

  return <img src={resolvedSrc} alt={alt} {...props} />;
};
